import React, { useRef } from "react";
import { FormGroup, ControlLabel, Checkbox, Dropdown, MenuItem, Button, FormControl, Glyphicon } from "react-bootstrap";
import moment from "moment";
import locale from "../../../../../locale";
import FormControlLanguage from "../../../../UI/FormControlLanguage";
import DatetimeRangePicker from "../../../../DatetimeRangePicker";

const eventFormatList = ['online', 'offline', 'hybrid'];

export default ({ block, blockProperties, onUpdateBlockProperties, onSave, onSaveFile }) => {
    const imageInputRef = useRef(null);

    const handleChangeDate = (e, picker) => {
        if (!picker) {
            let time = e.target.value.split(' - ');
            picker = {
                startDate: moment(time[0]),
                endDate: moment(time[1]),
            }
        }

        const dateEventStart = picker.startDate.unix();
        const dateEventStop = picker.endDate.unix();

        onSave({dateEventStart, dateEventStop});
	}

    return (
        <>
            <FormGroup>
                <ControlLabel>{locale('settings.title')}</ControlLabel>
                <FormControlLanguage
                    type="text"
                    values={{
                        ru: blockProperties.titleRu,
                        en: blockProperties.titleEn,
                    }}
                    onChange={{
                        ru: (e) => onUpdateBlockProperties({ titleRu: e.target.value }),
                        en: (e) => onUpdateBlockProperties({ titleEn: e.target.value }),
                    }}
                    onBlur={() => onSave({ titleRu: blockProperties.titleRu, titleEn: blockProperties.titleEn })}
                />
            </FormGroup>
            <FormGroup>
                <ControlLabel>{locale('settings.subtitle')}</ControlLabel>
                <FormControlLanguage
                    type="text"
                    values={{
                        ru: blockProperties.subtitleRu,
                        en: blockProperties.subtitleEn,
                    }}
                    onChange={{
                        ru: (e) => onUpdateBlockProperties({ subtitleRu: e.target.value }),
                        en: (e) => onUpdateBlockProperties({ subtitleEn: e.target.value }),
                    }}
                    onBlur={() => onSave({ subtitleRu: blockProperties.subtitleRu, subtitleEn: blockProperties.subtitleEn })}
                />
            </FormGroup>

            <FormGroup>
                <ControlLabel>{locale('settings.cover.dateEvent')}</ControlLabel>
                <Checkbox
                    checked={blockProperties?.showDateEvent}
                    onChange={(e) => onSave({ showDateEvent: e.target.checked })}
                >
                    {locale('settings.cover.showDateEvent')}
                </Checkbox>
            </FormGroup>
            {blockProperties.showDateEvent && (
                <DatetimeRangePicker
                    startDate={blockProperties?.dateEventStart ? moment.unix(blockProperties?.dateEventStart) : null}
                    endDate={blockProperties?.dateEventStop ? moment.unix(blockProperties?.dateEventStop) : null}
                    onApply={handleChangeDate}
                    applyClass="btn-primary"
                    cancelClass="btn-link"
                    style={{ marginBottom: '20px' }}
                >
                    <FormControl
                        size="40"
                        type="text"
                        name="dateEvent"
                        value={blockProperties?.dateEventStart && blockProperties?.dateEventStop ? `${moment.unix(blockProperties?.dateEventStart).format('YYYY-MM-DD')} - ${moment.unix(blockProperties?.dateEventStop).format('YYYY-MM-DD')}` : ' - '}
                        onChange={handleChangeDate}
                    />
                </DatetimeRangePicker>
            )}

            <FormGroup>
                <ControlLabel>{locale('settings.cover.timeEvent')}</ControlLabel>
                <Checkbox
                    checked={blockProperties?.showTimeEvent}
                    onChange={(e) => onSave({ showTimeEvent: e.target.checked })}
                >
                    {locale('settings.cover.showTimeEvent')}
                </Checkbox>
            </FormGroup>
            {blockProperties.showTimeEvent && (
                <FormGroup>
                    <FormControl
                        type="time"
                        step="60"
                        value={blockProperties.timeEvent}
                        onChange={(e) => onUpdateBlockProperties({ timeEvent: e.target.value })}
                        onBlur={() => onSave({ timeEvent: blockProperties.timeEvent})}
                    />
                </FormGroup>
            )}

            <FormGroup>
                <ControlLabel>{locale('settings.cover.participationType')}</ControlLabel>
                <Checkbox
                    checked={blockProperties?.showParticipationType}
                    onChange={(e) => onSave({ showParticipationType: e.target.checked })}
                >
                    {locale('settings.cover.showParticipationType')}
                </Checkbox>
            </FormGroup>
            {blockProperties.showParticipationType && (
                <FormGroup>
                    <Dropdown id="participationType" style={{ marginBottom: '20px' }}>
                        <Dropdown.Toggle>
                            {locale(`participationType.${blockProperties?.participationType || eventFormatList[0]}`)}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {
                                eventFormatList.map((item) => (
                                    <MenuItem
                                        key={item}
                                        onClick={() => onSave({ participationType: item })}
                                    >
                                        {locale(`participationType.${item}`)}
                                    </MenuItem>
                                ))
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </FormGroup>
            )}

            <FormGroup>
                <ControlLabel>{block.imageUrl ? "Изменить" : "Добавить"} Фон</ControlLabel>
                {block.imageUrl && <div><img src={block.imageUrl} style={{ maxWidth: '100%', maxHeight: 120 }} alt="" /></div>}
                <div>
                    <Button onClick={() => imageInputRef.current?.click()}><Glyphicon glyph="folder-open" /></Button>
                    {' '}
                    {block.imageUrl && <Button onClick={() => onSaveFile('image', 'DELETE')} bsStyle="danger"><Glyphicon glyph="trash" /></Button>}
                </div>
                <FormControl
                    type="file"
                    onChange={(e) => onSaveFile('image', e.target.files[0] || null)}
                    inputRef={ref => imageInputRef.current = ref}
                    style={{ display: 'none' }}
                />
            </FormGroup>
        </>
    )
};
